/* eslint-disable @nx/enforce-module-boundaries */
import { NotificationIcon } from '@mybridge/icons';
import {
  HStack,
  IconButton,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Box,
  PopoverFooter,
  Button,
  Heading,
  VStack,
  Card,
  Stack,
  Container,
  Spinner,
} from '@mybridge/ui';
import { Text } from '@mybridge/ui/text';
import React, { useEffect, useRef, useState } from 'react';
import { ThreeDotsIcon, EmptyNotifIcon } from '@mybridge/icons';
import { useDispatch, useSelector } from 'react-redux';
import { getNotificationList, markAllRead } from 'v4/store/actions/notification.actions';
import { isBeforeToday, isToday } from 'v4/utils/utils';
import moment from 'moment';
import NotificationCard from 'v4/snippets/auth/auth-header/notifications/notification-card';
import SectionLoader from 'v4/components/common/loader/sectionLoader';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import Head from 'next/head';
import { SiteShortcutLinks } from 'v4/snippets/dashboard/site-shortcut-links';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';

const NotificationPage = () => {
  const dispatch = useDispatch();
  const { notificationsList, loading, updatedStatus } = useSelector(
    (state) => state.notifications
  );
  const { t } = useTranslator();
  const { loggedIn } = useSelector((state) => state.user);
  const { globalNotifCount } = useSelector((state) => state.notifications);
  const todayDate = moment().format('YYYY-MM-DD');
  const [todayNotifs, setTodayNotifs] = useState([]);
  const [earlierNotifs, setEarlierNotifs] = useState([]);
  const [unreadMessage, setUnreadMessage] = useState([]);
  const [readMessage, setReadMessage] = useState([]);
  const [unreadListActive, setUnreadListActive] = useState(false);
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const analyticsTracked = useRef(false);

  const isToday = (meetingDate) => {
    return moment(meetingDate).format('YYYY-MM-DD') === todayDate;
  };

  const isBeforeToday = (meetingDate) => {
    return moment(meetingDate).isBefore(todayDate);
  };

  // useEffect(() => {
  //   console.log("Read messages updated:", readMessage.length);
  // }, [readMessage]);
  
  // useEffect(() => {
  //   console.log("Unread messages updated:", unreadMessage.length);
  // }, [unreadMessage]);

  useEffect(() => {
    dispatch(getNotificationList());
    
    if (!analyticsTracked.current && userProfileInfo?.slug) {
      trackEvent(ANALYTICS_EVENTS.Notifications, userProfileInfo?.slug);
      analyticsTracked.current = true;
    }
  }, []);

  useEffect(() => {
    if (updatedStatus) {
      dispatch(getNotificationList());
    }
  }, [updatedStatus]);

  // useEffect(() => {
  //   if (notificationsList?.length) {
  //     setTodayNotifs([]);
  //     setEarlierNotifs([]);
  //     setUnreadMessage([]);
  //     notificationsList?.forEach((message) => {
  //       if (isToday(message.created_at))
  //         setTodayNotifs((prevState) => [message, ...prevState]);
  //       else if (isBeforeToday(message.created_at))
  //         setEarlierNotifs((prevState) => [message, ...prevState]);
  //       if (message.status === 1)
  //         setUnreadMessage((prevState) => [message, ...prevState]);
  //     });
  //   }
  // }, [notificationsList]);

  // useEffect(() => {
  //   if (notificationsList?.length) {
  //     setTodayNotifs([]);
  //     setEarlierNotifs([]);
  //     setUnreadMessage([]);
  
  //     // Create maps to track unique notifications by ID
  //     const todayMap = {};
  //     const earlierMap = {};
  //     const unreadMap = {};
  
  //     notificationsList?.forEach((message) => {
  //       if (isToday(message.created_at)) {
  //         todayMap[message.data?.id] = message;
  //       }
  //       else if (isBeforeToday(message.created_at)) {
  //         earlierMap[message.data?.id] = message;
  //       }
  //       if (message.status === 1) {
  //         unreadMap[message.data?.id] = message;
  //       }
  //     });
  //     // Convert maps back to arrays with unique messages
  //     setTodayNotifs(Object.values(todayMap));
  //     setEarlierNotifs(Object.values(earlierMap));
  //     setUnreadMessage(Object.values(unreadMap));
  //   }
  // }, [notificationsList]);

  useEffect(() => {
    if (notificationsList?.length) {
      setTodayNotifs([]);
      setEarlierNotifs([]);
      setUnreadMessage([]);
      setReadMessage([]);
      
      notificationsList?.forEach((message) => {
        if (isToday(message.created_at))
          setTodayNotifs((prevState) => [message, ...prevState]);
        else if (isBeforeToday(message.created_at))
          setEarlierNotifs((prevState) => [message, ...prevState]);
      
        // Check status and add to appropriate arrays
        if (message.status === 1) {
          setUnreadMessage((prevState) => [message, ...prevState]);
        } else if (message.status === 2) {
          setReadMessage((prevState) => [message, ...prevState]);
        }
      });
      
    }
  }, [notificationsList]);

  const todaysSortArray = todayNotifs
    ?.map((item) => ({ ...item, momentDate: moment(item.created_at) }))
    .sort((a, b) => a.momentDate - b.momentDate);
  const earlierSortArray = earlierNotifs
    ?.map((item) => ({ ...item, momentDate: moment(item.created_at) }))
    .sort((a, b) => a.momentDate - b.momentDate);
  const unreadSortArray = unreadMessage
    ?.map((item) => ({ ...item, momentDate: moment(item.created_at) }))
    .sort((a, b) => a.momentDate - b.momentDate);
  const readSortArray = readMessage
    ?.map((item) => ({ ...item, momentDate: moment(item.created_at) }))
    .sort((a, b) => a.momentDate - b.momentDate);

  return (
    <AuthenticatedProviders>
      <Head>
        <title>
          {loggedIn && globalNotifCount ? `(${globalNotifCount})` : ''}{' '}
          {t('common.notifications') || "Notifications"} | myBridge.me
        </title>
      </Head>
      <Container maxW="1350px" py={[0, 6]} width={isMobile ? "100%" : "100%"}>
        <HStack alignItems="stretch" spacing={4} bg="white"minH={['auto', 'auto', '120vh']}>
          <Box
            h={!isMobile && "85vh"}
            pos={!isMobile && "sticky"}
            top={!isMobile && "90px"}
            width={['100%', '10%', '10%', '20%']}
            display={['none', 'block']}
          >
            <SiteShortcutLinks />
          </Box>
        
          {!loading ? (
            <Stack flex={1} maxW="800px">
              {/* <Card p={["2px", "10px", "20px"]} shadow="none" width={['100%', '800px']}> */}
              <Card p={["2px", "10px", "20px"]} shadow="none" width="100%">
                <VStack alignItems="flex-start">
                  <Heading fontSize={'17px'}  fontWeight={"600"} flex={1} color="#3D5A80">
                  {t('common.notifications') || "Notifications"}
                  </Heading>
                </VStack>
                <Tabs variant="soft-rounded" colorScheme="gray">
                  <TabList p={["10px", "10px", "0px"]} mt="2%">
                    <Tab py="2px">{t('publicProfile.all') || "All"}</Tab>
                    <Tab py="2px">{t('notification.Read')||"Read"}</Tab>
                    <Tab py="2px">{t('teams.unread') || "Unread"}</Tab>
                    <Text 
                      onClick={() => {dispatch(markAllRead({ status: unreadMessage.length === 0 ? 1 : 2 }))}} 
                      cursor="pointer" 
                      py="2px" 
                      fontSize={['14px', 'md']}
                      ml="auto" 
                      color="#000" 
                      display='flex'
                      alignItems='center'
                      gap={1}
                      px="2%"
                    >
                      {unreadMessage.length === 0 
                        ? t('otherModules.mark_all_as_unread') || "Mark all as unread" 
                        : t('notification.MarkAllRead') || "Mark all as read"}
                      {loading ? <Spinner size="sm"/> : ''}
                    </Text>
                  </TabList>
                  <TabPanels>
                    {/* All notifications tab */}
                    <TabPanel px="0">
                      {!loading && notificationsList && todayNotifs.length ? (
                        <>
                          <Text fontWeight="bold" px={["10px", "10px", "0px"]}> {t('profileNetwork.new') || "New"}</Text>
                          {todaysSortArray?.reverse().map((message, i) => (
                            <NotificationCard key={i} details={message} />
                          ))}
                        </>
                      ) : (
                        ''
                      )}
                     
                      {!loading && notificationsList && earlierNotifs.length ? (
                        <>
                          <Text fontWeight="bold" px={["10px", "10px", "0px"]}>{t('profileNetwork.earlier') || "Earlier"}</Text>
                          {earlierSortArray?.reverse().map((message, i) => (
                            <NotificationCard key={i} details={message} />
                          ))}
                        </>
                      ) : (
                        <Box align="center" py="25px" w="100%">
                          <EmptyNotifIcon />
                        </Box>
                      )}
                    </TabPanel>
                    {/* Read notifications tab */}
                    <TabPanel px="0">
                      {!loading && notificationsList && readMessage.length ? (
                        <>
                          <Text fontWeight="bold" px={["10px", "10px", "0px"]}>{t("notification.Read Notification")||"Read Notifications"}</Text>
                          {readSortArray?.reverse().map((message, i) => (
                            <NotificationCard key={i} details={message} />
                          ))}
                        </>
                      ) : (
                        <Box align="center" py="25px" w="100%">
                          <Text mb={4}>{t("notification.No Read Notification")||"No read notifications"}</Text>
                          <EmptyNotifIcon />
                        </Box>
                      )}
                    </TabPanel>
                    {/* Unread notifications tab */}
                    <TabPanel px="0">
                      {!loading && notificationsList && unreadMessage.length ? (
                        <>
                          <Text fontWeight="bold" px={["10px", "10px", "0px"]}>{t('profileNetwork.new') || "New"}</Text>
                          {unreadSortArray?.reverse().map((message, i) => (
                            <NotificationCard key={i} details={message} />
                          ))}
                        </>
                      ) : (
                        <Box align="center" py="25px" w="100%">
                          <Text mb={4}>{t("notification.No Unread Notification")||"No unread notifications"}</Text>
                          <EmptyNotifIcon />
                        </Box>
                      )}
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </Card>
            </Stack>
          ) : (
            <HStack justifyContent="center" alignItems="center" minHeight="100vh" width="100%">
            <SectionLoader />
          </HStack>
          )}
        </HStack>
      </Container>
    </AuthenticatedProviders>
  );
};

export default NotificationPage;
